<template>
	<!-- 峰值客数 -->
	<keep-alive>
		<div style="width: 100%;">
			<div style="float:right;">
				<span class="grid-content">订单类型 </span>
				<el-select v-model="filter.orderType" @change="getlist()"
					style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
					<el-option v-for="item in orderTypeList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<span class="grid-content">店铺类型 </span>
				<el-select v-model="filter.type" size="small" style="width: 120px;margin-right:25px;"
					@change="filter.storeId = '',getlist()">
					<el-option label="全部" value="1"></el-option>
					<el-option label="地铁店" value="2"></el-option>
					<el-option label="非地铁店" value="3"></el-option>
				</el-select>
				<span class="grid-content">门店 </span>
				<el-select ref="optionRef" @change="filter.type = '1',getlist()" v-model="filter.storeId"
					placeholder="全部门店" clearable style="width: 180px;margin-right:25px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					<el-option-group label="结业门店">
						<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					</el-option>
				</el-select>
				<span class="grid-content">时间</span>
				<el-date-picker v-model="filter.time" @change="getlist()" type="daterange" size="small"
					style="margin-left: 10px;margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd"
					range-separator="至">
				</el-date-picker>
				<el-button type="primary" style="float:right;margin-left: 3px;" size="small"
					@click="expor()">导出</el-button>
				<el-button type="primary" style="float:right;margin-left: 3px;" size="small"
					@click="getlist()">筛选</el-button>
			</div>
			<div>
				<span> 总数: </span>
				<span class="most">{{this.total}}单</span>
				<!-- <span>最高客数时间段: </span>
				<span class="most">{{this.mostTime}}</span>
				<span> 最高客数: </span>
				<span class="most">{{this.mostCustomer}}人</span> -->
			</div>
			<div id="option" style="width: 100%;height:50vh;"></div>
		</div>
		<div>
		</div>
	</keep-alive>
</template>

<script>
	import {
		url
	} from '../../../utils/index.js'
	import * as echarts from 'echarts';
	import {
		export2Excel
	} from '../../../common/js/util'
	export default {
		data() {
			return {
				hiarlist: [],
				url: url(),
				list: [],
				total: '',
				storeEnd: [],
				storeList: [],
				storeName: "全部门店",
				filter: {
					time: [],
					storeId: null,
					type: "1"
				},
				orderTypeList: [{
						label: "全部",
						value: "",
					}, {
						label: "剪发订单", //含染发订单、美团
						value: "1",
					}, {
						label: "会员权益订单",
						value: "11",
					}, {
						label: "抖音订单",
						value: "4",
					}
					// , {
					// 	label: "美团订单",
					// 	value: "9",
					// }, 
				],
				mostCustomer: 0,
				mostTime: '',
				total: '', //总客数、总订单数
				option: {
					toolbox: {
						feature: {
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						},
						tooltip: {
							trigger: 'item'
						},
					},
					grid: {
						left: '2%',
						right: '2%',
						containLabel: true
					},
					legend: {
						data: ['排队单数', '支付单数', '取消单数']
					},
					color: [
						"#5186e6",
						"#69bdc2",
						"#59a862"
					],
					xAxis: {
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
							data: [],
							name: "排队单数",
							type: 'bar',
							label: {
								show: true,
								position: 'top'
							}
						}, {
							data: [],
							name: "支付单数",
							type: 'bar',
							label: {
								show: true,
								position: 'top'
							}
						},{
							data: [],
							name: "取消单数",
							type: 'bar',
							label: {
								show: true,
								position: 'top'
							}
						},
					]
				},
				columns: [{
						title: '门店',
						key: 'storeName'
					},
					{
						title: '排队单数',
						key: 'queuing'
					}, {
						title: '支付单数',
						key: 'success'
					}, {
						title: '取消单数',
						key: 'cancel'
					}, {
						title: '开始时间',
						key: 'startTime'
					}, {
						title: '结束时间',
						key: 'endTime'
					}, {
						title: '时间段',
						key: 'halfHour'
					}
				]
			}
		},
		mounted() {
			const date1 = new Date()
			const nowDay =
				`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}`
			this.filter.time[0] = nowDay + '-01';
			this.filter.time[1] = nowDay + '-' + (date1.getDate() < 10 ? ('0' + date1.getDate()) : date1.getDate());
			this.getstorelist()
			this.getlist()
		},
		methods: {
			showoptions() {

			},
			initChartLeft() {
				let option = this.$echarts.init(document.getElementById('option'))
				option.setOption(this.option);
				window.addEventListener("resize", () => {
					option.resize();
				})
			},
			// 获取门店列表
			getstorelist() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			onload() {
				location.reload()
			},
			getlist() {
				var a = "?startTime=" + this.filter.time[0] + "&endTime=" + this.filter.time[1]
				if (this.filter.orderType) {
					a += "&orderType=" + this.filter.orderType
				}
				if (this.filter.storeId) {
					a += "&storeId=" + this.filter.storeId
					this.storeName = this.$refs.optionRef.selected.$options.propsData.label
				} else {
					if (this.filter.type == null) {
						this.filter.type = 1
						this.storeName = "全部门店"
					} else if (this.filter.type == 2) {
						this.storeName = "地铁店"
					} else if (this.filter.type == 3) {
						this.storeName = "非地铁店"
					} else if (this.filter.type == 1) {
						this.storeName = "全部门店"
					}
					a += "&type=" + this.filter.type;
				}
				this.$http.get("dOrder/halfHourCustomer" + a).then(res => {
					// this.mostTime = res.body.data.mostTime;//最高客数时间段
					// this.mostCustomer = res.body.data.mostCustomer;//最高客数
					this.total = res.body.data.total; //总客数（所选时间段内d_order_status_record中不含-1的订单总数 修改时间2023-10-24
					//面积图1
					this.option.series[0].data = []
					this.option.series[1].data = []
					this.option.series[2].data = []
					this.option.xAxis.data = []
					const a = res.body.data
					const b = a.halfHour.split(',') //时间段
					const c = a.inService.split(',') //服务中单数
					const d = a.cancel.split(',') //取消单数
					const e = a.queuing.split(',') //排队单数
					const f = a.success.split(',') //支付单数
					// this.option.series.data[0] = a.customer.split(',').map(Number)
					this.option.series[0].data = a.queuing.split(',').map(Number)
					this.option.series[1].data = a.success.split(',').map(Number)
					this.option.series[2].data = a.cancel.split(',').map(Number)
					for (var i = 0; i < b.length; i++) {
						this.option.xAxis.data.push(b[i])
						// this.option.xAxis.data[1].push(d[i])
						// this.option.xAxis.data[1].push(e[i])
						// this.option.xAxis.data[2].push(f[i])
					}
					this.initChartLeft()
				})
			},
			expor() {
				var that = this
				var a = []
				that.option.xAxis.data.forEach((ele, index) => {
					var b = {}
					b.storeName = this.storeName
					b.queuing = that.option.series[0].data[index]
					b.success = that.option.series[1].data[index]
					b.cancel = that.option.series[2].data[index]
					b.halfHour = that.option.xAxis.data[index]
					b.startTime = this.filter.time[0]
					b.endTime = this.filter.time[1]
					a.push(b)
				})
				export2Excel(this.columns, a)
			},
			// export01() {
			// 	var a = "?month=" + this.filter.month +
			// 		"&storeId=" + this.filter.storeId +
			// 		"&pageNum=" + this.pageNo +
			// 		"&pageSize=" + this.pageSize +
			// 		"&level=" + this.level+
			// 		"&type=" + this.filter.type

			// 	window.location.assign(this.url + "dStoreFile/exportDy" + a)
			// }
		}
	}
</script>

<style lang="less" scoped>
	.most {
		font-size: 24px;
		font-weight: 600;
		margin-right: 100px;
	}
	/deep/.el-select-dropdown__item {
		width:220px;
	}
</style>